const STORAGE_BASE = "https://api.niqsng.org/storage";

/** Resolve a stored file path (or an already-absolute URL) to a viewable URL. */
export function firmStorageUrl(pathOrUrl?: string | null): string | null {
  if (!pathOrUrl) return null;
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  return `${STORAGE_BASE}/${pathOrUrl.replace(/^\//, "")}`;
}

/**
 * Hand the browser to OnePay. Their gateway takes a form POST, not a URL, so the
 * page builds one and submits it — for the registration fee and the donation
 * alike, which is why this lives here rather than in either page.
 */
export function redirectToOnePay(res: any) {
  const form = document.createElement("form");
  form.method = "POST";
  form.id = "OnePay_form";
  form.name = "OnePay_form";
  form.action = res.payment_url || "https://vuvaa.com/ONEPAY/mod/live/main";
  const fields: Record<string, any> = {
    merchant_reg_id: res.merchant_reg_id, amt_paid: res.amt_paid, merch_trans_id: res.merch_trans_id,
    client_phone: res.client_phone, product_desc: res.product_desc,
    client_email: res.client_email, client_name: res.client_name,
  };
  Object.entries(fields).forEach(([k, v]) => {
    const i = document.createElement("input");
    i.type = "hidden"; i.name = k; i.value = String(v ?? "");
    form.appendChild(i);
  });
  document.body.appendChild(form);
  form.submit();
}
